/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name PayrollAdjustmentEditScheduleCtrl
 * Cook Brothers Adjustments
 * We can still use Adjustment within the controller/route/factory but not once we are interrogating any data from Cyrus
 */
angular.module('mercury.modules.time.payroll.adjustment')
.controller('PayrollAdjustmentEditScheduleCtrl', ["dialog", "$scope", function(dialog, $scope) {
  $scope.scheduleTypes = [
    {description: 'Never', id: 0},
    {description: 'Daily', id: 1},
    {description: 'Weekly', id: 2},
    {description: 'Monthly', id: 3},
    {description: 'Yearly', id: 4}
  ];

  $scope.repeatDays = [
    {label: 'M', value: 'Monday'},
    {label: 'T', value: 'Tuesday'},
    {label: 'W', value: 'Wednesday'},
    {label: 'T', value: 'Thursday'},
    {label: 'F', value: 'Friday'},
    {label: 'S', value: 'Saturday'},
    {label: 'S', value: 'Sunday'}
  ];

  if ($scope.scheduleEdit.repeatEnd === null) {
    $scope.selectedEnds = 'never';
  } else {
    $scope.selectedEnds = 'onDate';
  }

  $scope.scheduleEdit.daysArray = ($scope.scheduleEdit.days) ? $scope.scheduleEdit.days.split(',') : [];

  $scope.setEndsRadio = function() {
    if ($scope.selectedEnds == 'never') {
      $scope.scheduleEdit.repeatEnd = null;
    } else {
      $scope.scheduleEdit.repeatEnd = moment($scope.scheduleEdit.datestampStart).mEndOf('month').format();
    }
  };

  $scope.completeAdjustmentSchedule = function() {
    $scope.scheduleForm.$setSubmitted();
    if ($scope.scheduleForm.$invalid) {
      return;
    }

    dialog.close($scope.scheduleEdit);
  };

  $scope.toggleDaySelection = function(dayValue) {
    var daysArray = $scope.scheduleEdit.daysArray;

    var existingIndex = daysArray.indexOf(dayValue);

    // is currently selected
    if (existingIndex > -1) {
      daysArray.splice(existingIndex, 1);
    } else {
      daysArray.push(dayValue);
    }

    $scope.scheduleEdit.days = daysArray.join(',');
  };

  $scope.setRepeatType = function(selectedRepeat) {
    if (selectedRepeat === 0) {
      $scope.scheduleEdit.repeatEnd = null;
      $scope.selectedEnds = 'never';
    }

    if (selectedRepeat != 2) {
      $scope.scheduleEdit.days = '';
      $scope.scheduleEdit.daysArray = [];
    }
  };
}]);
